/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.base = (function() {

    /**
     * Namespace base.
     * @exports base
     * @namespace
     */
    var base = {};

    base.RequestType = (function() {

        /**
         * Properties of a RequestType.
         * @memberof base
         * @interface IRequestType
         * @property {string|null} [data] RequestType data
         * @property {string|null} [token] RequestType token
         * @property {string|null} [deviceId] RequestType deviceId
         * @property {user.IUserAgent|null} [userAgent] RequestType userAgent
         * @property {string|null} [appId] RequestType appId
         */

        /**
         * Constructs a new RequestType.
         * @memberof base
         * @classdesc Represents a RequestType.
         * @implements IRequestType
         * @constructor
         * @param {base.IRequestType=} [properties] Properties to set
         */
        function RequestType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestType data.
         * @member {string} data
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.data = "";

        /**
         * RequestType token.
         * @member {string} token
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.token = "";

        /**
         * RequestType deviceId.
         * @member {string} deviceId
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.deviceId = "";

        /**
         * RequestType userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.userAgent = null;

        /**
         * RequestType appId.
         * @member {string} appId
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.appId = "";

        /**
         * Creates a new RequestType instance using the specified properties.
         * @function create
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType=} [properties] Properties to set
         * @returns {base.RequestType} RequestType instance
         */
        RequestType.create = function create(properties) {
            return new RequestType(properties);
        };

        /**
         * Encodes the specified RequestType message. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.appId);
            return writer;
        };

        /**
         * Encodes the specified RequestType message, length delimited. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.token = reader.string();
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                case 4:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.appId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestType message.
         * @function verify
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            return null;
        };

        /**
         * Creates a RequestType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestType} RequestType
         */
        RequestType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestType)
                return object;
            var message = new $root.base.RequestType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.token != null)
                message.token = String(object.token);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".base.RequestType.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            if (object.appId != null)
                message.appId = String(object.appId);
            return message;
        };

        /**
         * Creates a plain object from a RequestType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestType
         * @static
         * @param {base.RequestType} message RequestType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.token = "";
                object.deviceId = "";
                object.userAgent = null;
                object.appId = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            return object;
        };

        /**
         * Converts this RequestType to JSON.
         * @function toJSON
         * @memberof base.RequestType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestType;
    })();

    base.ResponseType = (function() {

        /**
         * Properties of a ResponseType.
         * @memberof base
         * @interface IResponseType
         * @property {number|Long|null} [code] ResponseType code
         * @property {string|null} [msg] ResponseType msg
         * @property {string|null} [cnMsg] ResponseType cnMsg
         * @property {string|null} [error] ResponseType error
         * @property {string|null} [requestId] ResponseType requestId
         * @property {number|Long|null} [requestTime] ResponseType requestTime
         * @property {string|null} [author] ResponseType author
         * @property {string|null} [platform] ResponseType platform
         * @property {string|null} [data] ResponseType data
         */

        /**
         * Constructs a new ResponseType.
         * @memberof base
         * @classdesc Represents a ResponseType.
         * @implements IResponseType
         * @constructor
         * @param {base.IResponseType=} [properties] Properties to set
         */
        function ResponseType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseType code.
         * @member {number|Long} code
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType msg.
         * @member {string} msg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.msg = "";

        /**
         * ResponseType cnMsg.
         * @member {string} cnMsg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.cnMsg = "";

        /**
         * ResponseType error.
         * @member {string} error
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.error = "";

        /**
         * ResponseType requestId.
         * @member {string} requestId
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestId = "";

        /**
         * ResponseType requestTime.
         * @member {number|Long} requestTime
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType author.
         * @member {string} author
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.author = "";

        /**
         * ResponseType platform.
         * @member {string} platform
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.platform = "";

        /**
         * ResponseType data.
         * @member {string} data
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.data = "";

        /**
         * Creates a new ResponseType instance using the specified properties.
         * @function create
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType=} [properties] Properties to set
         * @returns {base.ResponseType} ResponseType instance
         */
        ResponseType.create = function create(properties) {
            return new ResponseType(properties);
        };

        /**
         * Encodes the specified ResponseType message. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.code);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            if (message.cnMsg != null && Object.hasOwnProperty.call(message, "cnMsg"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cnMsg);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
            if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.requestId);
            if (message.requestTime != null && Object.hasOwnProperty.call(message, "requestTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.requestTime);
            if (message.author != null && Object.hasOwnProperty.call(message, "author"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.author);
            if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.platform);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.data);
            return writer;
        };

        /**
         * Encodes the specified ResponseType message, length delimited. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.code = reader.int64();
                    break;
                case 2:
                    message.msg = reader.string();
                    break;
                case 3:
                    message.cnMsg = reader.string();
                    break;
                case 4:
                    message.error = reader.string();
                    break;
                case 5:
                    message.requestId = reader.string();
                    break;
                case 6:
                    message.requestTime = reader.int64();
                    break;
                case 7:
                    message.author = reader.string();
                    break;
                case 8:
                    message.platform = reader.string();
                    break;
                case 9:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseType message.
         * @function verify
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                if (!$util.isString(message.cnMsg))
                    return "cnMsg: string expected";
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                if (!$util.isString(message.requestId))
                    return "requestId: string expected";
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (!$util.isInteger(message.requestTime) && !(message.requestTime && $util.isInteger(message.requestTime.low) && $util.isInteger(message.requestTime.high)))
                    return "requestTime: integer|Long expected";
            if (message.author != null && message.hasOwnProperty("author"))
                if (!$util.isString(message.author))
                    return "author: string expected";
            if (message.platform != null && message.hasOwnProperty("platform"))
                if (!$util.isString(message.platform))
                    return "platform: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            return null;
        };

        /**
         * Creates a ResponseType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseType} ResponseType
         */
        ResponseType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseType)
                return object;
            var message = new $root.base.ResponseType();
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = false;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber();
            if (object.msg != null)
                message.msg = String(object.msg);
            if (object.cnMsg != null)
                message.cnMsg = String(object.cnMsg);
            if (object.error != null)
                message.error = String(object.error);
            if (object.requestId != null)
                message.requestId = String(object.requestId);
            if (object.requestTime != null)
                if ($util.Long)
                    (message.requestTime = $util.Long.fromValue(object.requestTime)).unsigned = false;
                else if (typeof object.requestTime === "string")
                    message.requestTime = parseInt(object.requestTime, 10);
                else if (typeof object.requestTime === "number")
                    message.requestTime = object.requestTime;
                else if (typeof object.requestTime === "object")
                    message.requestTime = new $util.LongBits(object.requestTime.low >>> 0, object.requestTime.high >>> 0).toNumber();
            if (object.author != null)
                message.author = String(object.author);
            if (object.platform != null)
                message.platform = String(object.platform);
            if (object.data != null)
                message.data = String(object.data);
            return message;
        };

        /**
         * Creates a plain object from a ResponseType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseType
         * @static
         * @param {base.ResponseType} message ResponseType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                object.msg = "";
                object.cnMsg = "";
                object.error = "";
                object.requestId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.requestTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requestTime = options.longs === String ? "0" : 0;
                object.author = "";
                object.platform = "";
                object.data = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber() : message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                object.cnMsg = message.cnMsg;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                object.requestId = message.requestId;
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (typeof message.requestTime === "number")
                    object.requestTime = options.longs === String ? String(message.requestTime) : message.requestTime;
                else
                    object.requestTime = options.longs === String ? $util.Long.prototype.toString.call(message.requestTime) : options.longs === Number ? new $util.LongBits(message.requestTime.low >>> 0, message.requestTime.high >>> 0).toNumber() : message.requestTime;
            if (message.author != null && message.hasOwnProperty("author"))
                object.author = message.author;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = message.platform;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            return object;
        };

        /**
         * Converts this ResponseType to JSON.
         * @function toJSON
         * @memberof base.ResponseType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseType;
    })();

    base.ResponseEncryptDataType = (function() {

        /**
         * Properties of a ResponseEncryptDataType.
         * @memberof base
         * @interface IResponseEncryptDataType
         * @property {string|null} [data] ResponseEncryptDataType data
         * @property {string|null} [key] ResponseEncryptDataType key
         */

        /**
         * Constructs a new ResponseEncryptDataType.
         * @memberof base
         * @classdesc Represents a ResponseEncryptDataType.
         * @implements IResponseEncryptDataType
         * @constructor
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         */
        function ResponseEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseEncryptDataType data.
         * @member {string} data
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.data = "";

        /**
         * ResponseEncryptDataType key.
         * @member {string} key
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.key = "";

        /**
         * Creates a new ResponseEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType instance
         */
        ResponseEncryptDataType.create = function create(properties) {
            return new ResponseEncryptDataType(properties);
        };

        /**
         * Encodes the specified ResponseEncryptDataType message. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            return writer;
        };

        /**
         * Encodes the specified ResponseEncryptDataType message, length delimited. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseEncryptDataType message.
         * @function verify
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            return null;
        };

        /**
         * Creates a ResponseEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         */
        ResponseEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseEncryptDataType)
                return object;
            var message = new $root.base.ResponseEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a ResponseEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.ResponseEncryptDataType} message ResponseEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this ResponseEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.ResponseEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseEncryptDataType;
    })();

    base.RequestEncryptDataType = (function() {

        /**
         * Properties of a RequestEncryptDataType.
         * @memberof base
         * @interface IRequestEncryptDataType
         * @property {string|null} [data] RequestEncryptDataType data
         * @property {string|null} [key] RequestEncryptDataType key
         * @property {string|null} [tempAesKey] RequestEncryptDataType tempAesKey
         */

        /**
         * Constructs a new RequestEncryptDataType.
         * @memberof base
         * @classdesc Represents a RequestEncryptDataType.
         * @implements IRequestEncryptDataType
         * @constructor
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         */
        function RequestEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestEncryptDataType data.
         * @member {string} data
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.data = "";

        /**
         * RequestEncryptDataType key.
         * @member {string} key
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.key = "";

        /**
         * RequestEncryptDataType tempAesKey.
         * @member {string} tempAesKey
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.tempAesKey = "";

        /**
         * Creates a new RequestEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType instance
         */
        RequestEncryptDataType.create = function create(properties) {
            return new RequestEncryptDataType(properties);
        };

        /**
         * Encodes the specified RequestEncryptDataType message. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            if (message.tempAesKey != null && Object.hasOwnProperty.call(message, "tempAesKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.tempAesKey);
            return writer;
        };

        /**
         * Encodes the specified RequestEncryptDataType message, length delimited. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                case 3:
                    message.tempAesKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestEncryptDataType message.
         * @function verify
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.tempAesKey != null && message.hasOwnProperty("tempAesKey"))
                if (!$util.isString(message.tempAesKey))
                    return "tempAesKey: string expected";
            return null;
        };

        /**
         * Creates a RequestEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         */
        RequestEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestEncryptDataType)
                return object;
            var message = new $root.base.RequestEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            if (object.tempAesKey != null)
                message.tempAesKey = String(object.tempAesKey);
            return message;
        };

        /**
         * Creates a plain object from a RequestEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.RequestEncryptDataType} message RequestEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
                object.tempAesKey = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.tempAesKey != null && message.hasOwnProperty("tempAesKey"))
                object.tempAesKey = message.tempAesKey;
            return object;
        };

        /**
         * Converts this RequestEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.RequestEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestEncryptDataType;
    })();

    return base;
})();

$root.user = (function() {

    /**
     * Namespace user.
     * @exports user
     * @namespace
     */
    var user = {};

    user.SSOUserInfo = (function() {

        /**
         * Properties of a SSOUserInfo.
         * @memberof user
         * @interface ISSOUserInfo
         * @property {string|null} [uid] SSOUserInfo uid
         * @property {string|null} [username] SSOUserInfo username
         * @property {string|null} [email] SSOUserInfo email
         * @property {string|null} [phone] SSOUserInfo phone
         * @property {string|null} [nickname] SSOUserInfo nickname
         * @property {string|null} [avatar] SSOUserInfo avatar
         * @property {string|null} [bio] SSOUserInfo bio
         * @property {Array.<string>|null} [city] SSOUserInfo city
         * @property {number|Long|null} [gender] SSOUserInfo gender
         * @property {string|null} [birthday] SSOUserInfo birthday
         * @property {number|Long|null} [status] SSOUserInfo status
         * @property {user.SSOUserInfo.IAdditionalInformation|null} [additionalInformation] SSOUserInfo additionalInformation
         * @property {user.SSOUserInfo.IAppData|null} [appData] SSOUserInfo appData
         * @property {number|Long|null} [creationTime] SSOUserInfo creationTime
         * @property {number|Long|null} [lastUpdateTime] SSOUserInfo lastUpdateTime
         * @property {number|Long|null} [lastSeenTime] SSOUserInfo lastSeenTime
         */

        /**
         * Constructs a new SSOUserInfo.
         * @memberof user
         * @classdesc Represents a SSOUserInfo.
         * @implements ISSOUserInfo
         * @constructor
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         */
        function SSOUserInfo(properties) {
            this.city = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SSOUserInfo uid.
         * @member {string} uid
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.uid = "";

        /**
         * SSOUserInfo username.
         * @member {string} username
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.username = "";

        /**
         * SSOUserInfo email.
         * @member {string} email
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.email = "";

        /**
         * SSOUserInfo phone.
         * @member {string} phone
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.phone = "";

        /**
         * SSOUserInfo nickname.
         * @member {string} nickname
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.nickname = "";

        /**
         * SSOUserInfo avatar.
         * @member {string} avatar
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.avatar = "";

        /**
         * SSOUserInfo bio.
         * @member {string} bio
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.bio = "";

        /**
         * SSOUserInfo city.
         * @member {Array.<string>} city
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.city = $util.emptyArray;

        /**
         * SSOUserInfo gender.
         * @member {number|Long} gender
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.gender = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo birthday.
         * @member {string} birthday
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.birthday = "";

        /**
         * SSOUserInfo status.
         * @member {number|Long} status
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo additionalInformation.
         * @member {user.SSOUserInfo.IAdditionalInformation|null|undefined} additionalInformation
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.additionalInformation = null;

        /**
         * SSOUserInfo appData.
         * @member {user.SSOUserInfo.IAppData|null|undefined} appData
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.appData = null;

        /**
         * SSOUserInfo creationTime.
         * @member {number|Long} creationTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo lastUpdateTime.
         * @member {number|Long} lastUpdateTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SSOUserInfo instance using the specified properties.
         * @function create
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         * @returns {user.SSOUserInfo} SSOUserInfo instance
         */
        SSOUserInfo.create = function create(properties) {
            return new SSOUserInfo(properties);
        };

        /**
         * Encodes the specified SSOUserInfo message. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phone);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            if (message.city != null && message.city.length)
                for (var i = 0; i < message.city.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.city[i]);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.gender);
            if (message.birthday != null && Object.hasOwnProperty.call(message, "birthday"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.birthday);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.status);
            if (message.additionalInformation != null && Object.hasOwnProperty.call(message, "additionalInformation"))
                $root.user.SSOUserInfo.AdditionalInformation.encode(message.additionalInformation, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.appData != null && Object.hasOwnProperty.call(message, "appData"))
                $root.user.SSOUserInfo.AppData.encode(message.appData, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.creationTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.lastUpdateTime);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.lastSeenTime);
            return writer;
        };

        /**
         * Encodes the specified SSOUserInfo message, length delimited. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.username = reader.string();
                    break;
                case 3:
                    message.email = reader.string();
                    break;
                case 4:
                    message.phone = reader.string();
                    break;
                case 5:
                    message.nickname = reader.string();
                    break;
                case 6:
                    message.avatar = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                case 8:
                    if (!(message.city && message.city.length))
                        message.city = [];
                    message.city.push(reader.string());
                    break;
                case 9:
                    message.gender = reader.int64();
                    break;
                case 10:
                    message.birthday = reader.string();
                    break;
                case 11:
                    message.status = reader.int64();
                    break;
                case 12:
                    message.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.appData = $root.user.SSOUserInfo.AppData.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.creationTime = reader.int64();
                    break;
                case 15:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 16:
                    message.lastSeenTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SSOUserInfo message.
         * @function verify
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SSOUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.city != null && message.hasOwnProperty("city")) {
                if (!Array.isArray(message.city))
                    return "city: array expected";
                for (var i = 0; i < message.city.length; ++i)
                    if (!$util.isString(message.city[i]))
                        return "city: string[] expected";
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (!$util.isInteger(message.gender) && !(message.gender && $util.isInteger(message.gender.low) && $util.isInteger(message.gender.high)))
                    return "gender: integer|Long expected";
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                if (!$util.isString(message.birthday))
                    return "birthday: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.additionalInformation != null && message.hasOwnProperty("additionalInformation")) {
                var error = $root.user.SSOUserInfo.AdditionalInformation.verify(message.additionalInformation);
                if (error)
                    return "additionalInformation." + error;
            }
            if (message.appData != null && message.hasOwnProperty("appData")) {
                var error = $root.user.SSOUserInfo.AppData.verify(message.appData);
                if (error)
                    return "appData." + error;
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a SSOUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.SSOUserInfo} SSOUserInfo
         */
        SSOUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.SSOUserInfo)
                return object;
            var message = new $root.user.SSOUserInfo();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.username != null)
                message.username = String(object.username);
            if (object.email != null)
                message.email = String(object.email);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.city) {
                if (!Array.isArray(object.city))
                    throw TypeError(".user.SSOUserInfo.city: array expected");
                message.city = [];
                for (var i = 0; i < object.city.length; ++i)
                    message.city[i] = String(object.city[i]);
            }
            if (object.gender != null)
                if ($util.Long)
                    (message.gender = $util.Long.fromValue(object.gender)).unsigned = false;
                else if (typeof object.gender === "string")
                    message.gender = parseInt(object.gender, 10);
                else if (typeof object.gender === "number")
                    message.gender = object.gender;
                else if (typeof object.gender === "object")
                    message.gender = new $util.LongBits(object.gender.low >>> 0, object.gender.high >>> 0).toNumber();
            if (object.birthday != null)
                message.birthday = String(object.birthday);
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.additionalInformation != null) {
                if (typeof object.additionalInformation !== "object")
                    throw TypeError(".user.SSOUserInfo.additionalInformation: object expected");
                message.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.fromObject(object.additionalInformation);
            }
            if (object.appData != null) {
                if (typeof object.appData !== "object")
                    throw TypeError(".user.SSOUserInfo.appData: object expected");
                message.appData = $root.user.SSOUserInfo.AppData.fromObject(object.appData);
            }
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = false;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SSOUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.SSOUserInfo} message SSOUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SSOUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.city = [];
            if (options.defaults) {
                object.uid = "";
                object.username = "";
                object.email = "";
                object.phone = "";
                object.nickname = "";
                object.avatar = "";
                object.bio = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.gender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gender = options.longs === String ? "0" : 0;
                object.birthday = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                object.additionalInformation = null;
                object.appData = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.city && message.city.length) {
                object.city = [];
                for (var j = 0; j < message.city.length; ++j)
                    object.city[j] = message.city[j];
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (typeof message.gender === "number")
                    object.gender = options.longs === String ? String(message.gender) : message.gender;
                else
                    object.gender = options.longs === String ? $util.Long.prototype.toString.call(message.gender) : options.longs === Number ? new $util.LongBits(message.gender.low >>> 0, message.gender.high >>> 0).toNumber() : message.gender;
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                object.birthday = message.birthday;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.additionalInformation != null && message.hasOwnProperty("additionalInformation"))
                object.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.toObject(message.additionalInformation, options);
            if (message.appData != null && message.hasOwnProperty("appData"))
                object.appData = $root.user.SSOUserInfo.AppData.toObject(message.appData, options);
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber() : message.creationTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            return object;
        };

        /**
         * Converts this SSOUserInfo to JSON.
         * @function toJSON
         * @memberof user.SSOUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SSOUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SSOUserInfo.AdditionalInformation = (function() {

            /**
             * Properties of an AdditionalInformation.
             * @memberof user.SSOUserInfo
             * @interface IAdditionalInformation
             */

            /**
             * Constructs a new AdditionalInformation.
             * @memberof user.SSOUserInfo
             * @classdesc Represents an AdditionalInformation.
             * @implements IAdditionalInformation
             * @constructor
             * @param {user.SSOUserInfo.IAdditionalInformation=} [properties] Properties to set
             */
            function AdditionalInformation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AdditionalInformation instance using the specified properties.
             * @function create
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation=} [properties] Properties to set
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation instance
             */
            AdditionalInformation.create = function create(properties) {
                return new AdditionalInformation(properties);
            };

            /**
             * Encodes the specified AdditionalInformation message. Does not implicitly {@link user.SSOUserInfo.AdditionalInformation.verify|verify} messages.
             * @function encode
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation} message AdditionalInformation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdditionalInformation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AdditionalInformation message, length delimited. Does not implicitly {@link user.SSOUserInfo.AdditionalInformation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation} message AdditionalInformation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdditionalInformation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AdditionalInformation message from the specified reader or buffer.
             * @function decode
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdditionalInformation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo.AdditionalInformation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AdditionalInformation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdditionalInformation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AdditionalInformation message.
             * @function verify
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AdditionalInformation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AdditionalInformation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             */
            AdditionalInformation.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SSOUserInfo.AdditionalInformation)
                    return object;
                return new $root.user.SSOUserInfo.AdditionalInformation();
            };

            /**
             * Creates a plain object from an AdditionalInformation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.AdditionalInformation} message AdditionalInformation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AdditionalInformation.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AdditionalInformation to JSON.
             * @function toJSON
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AdditionalInformation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AdditionalInformation;
        })();

        SSOUserInfo.AppData = (function() {

            /**
             * Properties of an AppData.
             * @memberof user.SSOUserInfo
             * @interface IAppData
             */

            /**
             * Constructs a new AppData.
             * @memberof user.SSOUserInfo
             * @classdesc Represents an AppData.
             * @implements IAppData
             * @constructor
             * @param {user.SSOUserInfo.IAppData=} [properties] Properties to set
             */
            function AppData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AppData instance using the specified properties.
             * @function create
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData=} [properties] Properties to set
             * @returns {user.SSOUserInfo.AppData} AppData instance
             */
            AppData.create = function create(properties) {
                return new AppData(properties);
            };

            /**
             * Encodes the specified AppData message. Does not implicitly {@link user.SSOUserInfo.AppData.verify|verify} messages.
             * @function encode
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData} message AppData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AppData message, length delimited. Does not implicitly {@link user.SSOUserInfo.AppData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData} message AppData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppData message from the specified reader or buffer.
             * @function decode
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SSOUserInfo.AppData} AppData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo.AppData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SSOUserInfo.AppData} AppData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppData message.
             * @function verify
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AppData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SSOUserInfo.AppData} AppData
             */
            AppData.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SSOUserInfo.AppData)
                    return object;
                return new $root.user.SSOUserInfo.AppData();
            };

            /**
             * Creates a plain object from an AppData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.AppData} message AppData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppData.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AppData to JSON.
             * @function toJSON
             * @memberof user.SSOUserInfo.AppData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppData;
        })();

        return SSOUserInfo;
    })();

    user.UserAgent = (function() {

        /**
         * Properties of a UserAgent.
         * @memberof user
         * @interface IUserAgent
         * @property {user.UserAgent.IBrowser|null} [browser] UserAgent browser
         * @property {user.UserAgent.IDevice|null} [device] UserAgent device
         * @property {user.UserAgent.IOS|null} [os] UserAgent os
         * @property {string|null} [deviceName] UserAgent deviceName
         */

        /**
         * Constructs a new UserAgent.
         * @memberof user
         * @classdesc Represents a UserAgent.
         * @implements IUserAgent
         * @constructor
         * @param {user.IUserAgent=} [properties] Properties to set
         */
        function UserAgent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserAgent browser.
         * @member {user.UserAgent.IBrowser|null|undefined} browser
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.browser = null;

        /**
         * UserAgent device.
         * @member {user.UserAgent.IDevice|null|undefined} device
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.device = null;

        /**
         * UserAgent os.
         * @member {user.UserAgent.IOS|null|undefined} os
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.os = null;

        /**
         * UserAgent deviceName.
         * @member {string} deviceName
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.deviceName = "";

        /**
         * Creates a new UserAgent instance using the specified properties.
         * @function create
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent=} [properties] Properties to set
         * @returns {user.UserAgent} UserAgent instance
         */
        UserAgent.create = function create(properties) {
            return new UserAgent(properties);
        };

        /**
         * Encodes the specified UserAgent message. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encode
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.browser != null && Object.hasOwnProperty.call(message, "browser"))
                $root.user.UserAgent.Browser.encode(message.browser, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.device != null && Object.hasOwnProperty.call(message, "device"))
                $root.user.UserAgent.Device.encode(message.device, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.os != null && Object.hasOwnProperty.call(message, "os"))
                $root.user.UserAgent.OS.encode(message.os, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.deviceName != null && Object.hasOwnProperty.call(message, "deviceName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceName);
            return writer;
        };

        /**
         * Encodes the specified UserAgent message, length delimited. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer.
         * @function decode
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.browser = $root.user.UserAgent.Browser.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.device = $root.user.UserAgent.Device.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.os = $root.user.UserAgent.OS.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.deviceName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserAgent message.
         * @function verify
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserAgent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.browser != null && message.hasOwnProperty("browser")) {
                var error = $root.user.UserAgent.Browser.verify(message.browser);
                if (error)
                    return "browser." + error;
            }
            if (message.device != null && message.hasOwnProperty("device")) {
                var error = $root.user.UserAgent.Device.verify(message.device);
                if (error)
                    return "device." + error;
            }
            if (message.os != null && message.hasOwnProperty("os")) {
                var error = $root.user.UserAgent.OS.verify(message.os);
                if (error)
                    return "os." + error;
            }
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                if (!$util.isString(message.deviceName))
                    return "deviceName: string expected";
            return null;
        };

        /**
         * Creates a UserAgent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UserAgent} UserAgent
         */
        UserAgent.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UserAgent)
                return object;
            var message = new $root.user.UserAgent();
            if (object.browser != null) {
                if (typeof object.browser !== "object")
                    throw TypeError(".user.UserAgent.browser: object expected");
                message.browser = $root.user.UserAgent.Browser.fromObject(object.browser);
            }
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".user.UserAgent.device: object expected");
                message.device = $root.user.UserAgent.Device.fromObject(object.device);
            }
            if (object.os != null) {
                if (typeof object.os !== "object")
                    throw TypeError(".user.UserAgent.os: object expected");
                message.os = $root.user.UserAgent.OS.fromObject(object.os);
            }
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            return message;
        };

        /**
         * Creates a plain object from a UserAgent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UserAgent
         * @static
         * @param {user.UserAgent} message UserAgent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserAgent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.browser = null;
                object.device = null;
                object.os = null;
                object.deviceName = "";
            }
            if (message.browser != null && message.hasOwnProperty("browser"))
                object.browser = $root.user.UserAgent.Browser.toObject(message.browser, options);
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.user.UserAgent.Device.toObject(message.device, options);
            if (message.os != null && message.hasOwnProperty("os"))
                object.os = $root.user.UserAgent.OS.toObject(message.os, options);
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            return object;
        };

        /**
         * Converts this UserAgent to JSON.
         * @function toJSON
         * @memberof user.UserAgent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserAgent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UserAgent.Browser = (function() {

            /**
             * Properties of a Browser.
             * @memberof user.UserAgent
             * @interface IBrowser
             * @property {string|null} [name] Browser name
             * @property {string|null} [major] Browser major
             * @property {string|null} [version] Browser version
             */

            /**
             * Constructs a new Browser.
             * @memberof user.UserAgent
             * @classdesc Represents a Browser.
             * @implements IBrowser
             * @constructor
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             */
            function Browser(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Browser name.
             * @member {string} name
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.name = "";

            /**
             * Browser major.
             * @member {string} major
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.major = "";

            /**
             * Browser version.
             * @member {string} version
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.version = "";

            /**
             * Creates a new Browser instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             * @returns {user.UserAgent.Browser} Browser instance
             */
            Browser.create = function create(properties) {
                return new Browser(properties);
            };

            /**
             * Encodes the specified Browser message. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.major != null && Object.hasOwnProperty.call(message, "major"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.major);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified Browser message, length delimited. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Browser message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Browser();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.major = reader.string();
                        break;
                    case 3:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Browser message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Browser message.
             * @function verify
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Browser.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.major != null && message.hasOwnProperty("major"))
                    if (!$util.isString(message.major))
                        return "major: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a Browser message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Browser} Browser
             */
            Browser.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Browser)
                    return object;
                var message = new $root.user.UserAgent.Browser();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.major != null)
                    message.major = String(object.major);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a Browser message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.Browser} message Browser
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Browser.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.major = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.major != null && message.hasOwnProperty("major"))
                    object.major = message.major;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this Browser to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Browser
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Browser.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Browser;
        })();

        UserAgent.Device = (function() {

            /**
             * Properties of a Device.
             * @memberof user.UserAgent
             * @interface IDevice
             * @property {string|null} [model] Device model
             * @property {string|null} [type] Device type
             * @property {string|null} [vendor] Device vendor
             */

            /**
             * Constructs a new Device.
             * @memberof user.UserAgent
             * @classdesc Represents a Device.
             * @implements IDevice
             * @constructor
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             */
            function Device(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Device model.
             * @member {string} model
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.model = "";

            /**
             * Device type.
             * @member {string} type
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.type = "";

            /**
             * Device vendor.
             * @member {string} vendor
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.vendor = "";

            /**
             * Creates a new Device instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             * @returns {user.UserAgent.Device} Device instance
             */
            Device.create = function create(properties) {
                return new Device(properties);
            };

            /**
             * Encodes the specified Device message. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.model);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.vendor);
                return writer;
            };

            /**
             * Encodes the specified Device message, length delimited. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Device message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Device();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.model = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        message.vendor = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Device message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Device message.
             * @function verify
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Device.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.model != null && message.hasOwnProperty("model"))
                    if (!$util.isString(message.model))
                        return "model: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    if (!$util.isString(message.vendor))
                        return "vendor: string expected";
                return null;
            };

            /**
             * Creates a Device message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Device} Device
             */
            Device.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Device)
                    return object;
                var message = new $root.user.UserAgent.Device();
                if (object.model != null)
                    message.model = String(object.model);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.vendor != null)
                    message.vendor = String(object.vendor);
                return message;
            };

            /**
             * Creates a plain object from a Device message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.Device} message Device
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Device.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.model = "";
                    object.type = "";
                    object.vendor = "";
                }
                if (message.model != null && message.hasOwnProperty("model"))
                    object.model = message.model;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    object.vendor = message.vendor;
                return object;
            };

            /**
             * Converts this Device to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Device
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Device.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Device;
        })();

        UserAgent.OS = (function() {

            /**
             * Properties of a OS.
             * @memberof user.UserAgent
             * @interface IOS
             * @property {string|null} [name] OS name
             * @property {string|null} [version] OS version
             */

            /**
             * Constructs a new OS.
             * @memberof user.UserAgent
             * @classdesc Represents a OS.
             * @implements IOS
             * @constructor
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             */
            function OS(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OS name.
             * @member {string} name
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.name = "";

            /**
             * OS version.
             * @member {string} version
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.version = "";

            /**
             * Creates a new OS instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             * @returns {user.UserAgent.OS} OS instance
             */
            OS.create = function create(properties) {
                return new OS(properties);
            };

            /**
             * Encodes the specified OS message. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified OS message, length delimited. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OS message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.OS();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OS message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OS message.
             * @function verify
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OS.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a OS message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.OS} OS
             */
            OS.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.OS)
                    return object;
                var message = new $root.user.UserAgent.OS();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a OS message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.OS} message OS
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OS.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this OS to JSON.
             * @function toJSON
             * @memberof user.UserAgent.OS
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OS.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OS;
        })();

        return UserAgent;
    })();

    user.GerUsers = (function() {

        /**
         * Properties of a GerUsers.
         * @memberof user
         * @interface IGerUsers
         */

        /**
         * Constructs a new GerUsers.
         * @memberof user
         * @classdesc Represents a GerUsers.
         * @implements IGerUsers
         * @constructor
         * @param {user.IGerUsers=} [properties] Properties to set
         */
        function GerUsers(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GerUsers instance using the specified properties.
         * @function create
         * @memberof user.GerUsers
         * @static
         * @param {user.IGerUsers=} [properties] Properties to set
         * @returns {user.GerUsers} GerUsers instance
         */
        GerUsers.create = function create(properties) {
            return new GerUsers(properties);
        };

        /**
         * Encodes the specified GerUsers message. Does not implicitly {@link user.GerUsers.verify|verify} messages.
         * @function encode
         * @memberof user.GerUsers
         * @static
         * @param {user.IGerUsers} message GerUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GerUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GerUsers message, length delimited. Does not implicitly {@link user.GerUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.GerUsers
         * @static
         * @param {user.IGerUsers} message GerUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GerUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GerUsers message from the specified reader or buffer.
         * @function decode
         * @memberof user.GerUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.GerUsers} GerUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GerUsers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GerUsers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GerUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.GerUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.GerUsers} GerUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GerUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GerUsers message.
         * @function verify
         * @memberof user.GerUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GerUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GerUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.GerUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.GerUsers} GerUsers
         */
        GerUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.user.GerUsers)
                return object;
            return new $root.user.GerUsers();
        };

        /**
         * Creates a plain object from a GerUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.GerUsers
         * @static
         * @param {user.GerUsers} message GerUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GerUsers.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GerUsers to JSON.
         * @function toJSON
         * @memberof user.GerUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GerUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GerUsers.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.GerUsers
             * @interface IRequest
             * @property {Array.<string>|null} [uids] Request uids
             */

            /**
             * Constructs a new Request.
             * @memberof user.GerUsers
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.GerUsers.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.uids = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request uids.
             * @member {Array.<string>} uids
             * @memberof user.GerUsers.Request
             * @instance
             */
            Request.prototype.uids = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.GerUsers.Request
             * @static
             * @param {user.GerUsers.IRequest=} [properties] Properties to set
             * @returns {user.GerUsers.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.GerUsers.Request.verify|verify} messages.
             * @function encode
             * @memberof user.GerUsers.Request
             * @static
             * @param {user.GerUsers.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uids != null && message.uids.length)
                    for (var i = 0; i < message.uids.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.uids[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.GerUsers.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GerUsers.Request
             * @static
             * @param {user.GerUsers.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.GerUsers.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GerUsers.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GerUsers.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.uids && message.uids.length))
                            message.uids = [];
                        message.uids.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GerUsers.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GerUsers.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.GerUsers.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uids != null && message.hasOwnProperty("uids")) {
                    if (!Array.isArray(message.uids))
                        return "uids: array expected";
                    for (var i = 0; i < message.uids.length; ++i)
                        if (!$util.isString(message.uids[i]))
                            return "uids: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GerUsers.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GerUsers.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GerUsers.Request)
                    return object;
                var message = new $root.user.GerUsers.Request();
                if (object.uids) {
                    if (!Array.isArray(object.uids))
                        throw TypeError(".user.GerUsers.Request.uids: array expected");
                    message.uids = [];
                    for (var i = 0; i < object.uids.length; ++i)
                        message.uids[i] = String(object.uids[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GerUsers.Request
             * @static
             * @param {user.GerUsers.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uids = [];
                if (message.uids && message.uids.length) {
                    object.uids = [];
                    for (var j = 0; j < message.uids.length; ++j)
                        object.uids[j] = message.uids[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.GerUsers.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GerUsers.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.GerUsers
             * @interface IResponse
             * @property {Array.<user.ISSOUserInfo>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof user.GerUsers
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.GerUsers.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<user.ISSOUserInfo>} list
             * @memberof user.GerUsers.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof user.GerUsers.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.GerUsers.Response
             * @static
             * @param {user.GerUsers.IResponse=} [properties] Properties to set
             * @returns {user.GerUsers.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.GerUsers.Response.verify|verify} messages.
             * @function encode
             * @memberof user.GerUsers.Response
             * @static
             * @param {user.GerUsers.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.user.SSOUserInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.GerUsers.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GerUsers.Response
             * @static
             * @param {user.GerUsers.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.GerUsers.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GerUsers.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GerUsers.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.user.SSOUserInfo.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GerUsers.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GerUsers.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.GerUsers.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.user.SSOUserInfo.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GerUsers.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GerUsers.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GerUsers.Response)
                    return object;
                var message = new $root.user.GerUsers.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".user.GerUsers.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".user.GerUsers.Response.list: object expected");
                        message.list[i] = $root.user.SSOUserInfo.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GerUsers.Response
             * @static
             * @param {user.GerUsers.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.user.SSOUserInfo.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.GerUsers.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GerUsers;
    })();

    return user;
})();

$root.saass = (function() {

    /**
     * Namespace saass.
     * @exports saass
     * @namespace
     */
    var saass = {};

    saass.GetDownloadUrls = (function() {

        /**
         * Properties of a GetDownloadUrls.
         * @memberof saass
         * @interface IGetDownloadUrls
         */

        /**
         * Constructs a new GetDownloadUrls.
         * @memberof saass
         * @classdesc Represents a GetDownloadUrls.
         * @implements IGetDownloadUrls
         * @constructor
         * @param {saass.IGetDownloadUrls=} [properties] Properties to set
         */
        function GetDownloadUrls(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetDownloadUrls instance using the specified properties.
         * @function create
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {saass.IGetDownloadUrls=} [properties] Properties to set
         * @returns {saass.GetDownloadUrls} GetDownloadUrls instance
         */
        GetDownloadUrls.create = function create(properties) {
            return new GetDownloadUrls(properties);
        };

        /**
         * Encodes the specified GetDownloadUrls message. Does not implicitly {@link saass.GetDownloadUrls.verify|verify} messages.
         * @function encode
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {saass.IGetDownloadUrls} message GetDownloadUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetDownloadUrls.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetDownloadUrls message, length delimited. Does not implicitly {@link saass.GetDownloadUrls.verify|verify} messages.
         * @function encodeDelimited
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {saass.IGetDownloadUrls} message GetDownloadUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetDownloadUrls.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetDownloadUrls message from the specified reader or buffer.
         * @function decode
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {saass.GetDownloadUrls} GetDownloadUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetDownloadUrls.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetDownloadUrls();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetDownloadUrls message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {saass.GetDownloadUrls} GetDownloadUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetDownloadUrls.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetDownloadUrls message.
         * @function verify
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetDownloadUrls.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetDownloadUrls message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {saass.GetDownloadUrls} GetDownloadUrls
         */
        GetDownloadUrls.fromObject = function fromObject(object) {
            if (object instanceof $root.saass.GetDownloadUrls)
                return object;
            return new $root.saass.GetDownloadUrls();
        };

        /**
         * Creates a plain object from a GetDownloadUrls message. Also converts values to other types if specified.
         * @function toObject
         * @memberof saass.GetDownloadUrls
         * @static
         * @param {saass.GetDownloadUrls} message GetDownloadUrls
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDownloadUrls.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetDownloadUrls to JSON.
         * @function toJSON
         * @memberof saass.GetDownloadUrls
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDownloadUrls.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetDownloadUrls.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof saass.GetDownloadUrls
             * @interface IRequest
             * @property {string|null} [shortId] Request shortId
             * @property {string|null} [path] Request path
             */

            /**
             * Constructs a new Request.
             * @memberof saass.GetDownloadUrls
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {saass.GetDownloadUrls.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request shortId.
             * @member {string} shortId
             * @memberof saass.GetDownloadUrls.Request
             * @instance
             */
            Request.prototype.shortId = "";

            /**
             * Request path.
             * @member {string} path
             * @memberof saass.GetDownloadUrls.Request
             * @instance
             */
            Request.prototype.path = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {saass.GetDownloadUrls.IRequest=} [properties] Properties to set
             * @returns {saass.GetDownloadUrls.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link saass.GetDownloadUrls.Request.verify|verify} messages.
             * @function encode
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {saass.GetDownloadUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.shortId != null && Object.hasOwnProperty.call(message, "shortId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.shortId);
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link saass.GetDownloadUrls.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {saass.GetDownloadUrls.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {saass.GetDownloadUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetDownloadUrls.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.shortId = reader.string();
                        break;
                    case 2:
                        message.path = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {saass.GetDownloadUrls.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.shortId != null && message.hasOwnProperty("shortId"))
                    if (!$util.isString(message.shortId))
                        return "shortId: string expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {saass.GetDownloadUrls.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.saass.GetDownloadUrls.Request)
                    return object;
                var message = new $root.saass.GetDownloadUrls.Request();
                if (object.shortId != null)
                    message.shortId = String(object.shortId);
                if (object.path != null)
                    message.path = String(object.path);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof saass.GetDownloadUrls.Request
             * @static
             * @param {saass.GetDownloadUrls.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.shortId = "";
                    object.path = "";
                }
                if (message.shortId != null && message.hasOwnProperty("shortId"))
                    object.shortId = message.shortId;
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof saass.GetDownloadUrls.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetDownloadUrls.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof saass.GetDownloadUrls
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof saass.GetDownloadUrls
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {saass.GetDownloadUrls.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {saass.GetDownloadUrls.IResponse=} [properties] Properties to set
             * @returns {saass.GetDownloadUrls.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link saass.GetDownloadUrls.Response.verify|verify} messages.
             * @function encode
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {saass.GetDownloadUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link saass.GetDownloadUrls.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {saass.GetDownloadUrls.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {saass.GetDownloadUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetDownloadUrls.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {saass.GetDownloadUrls.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {saass.GetDownloadUrls.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.saass.GetDownloadUrls.Response)
                    return object;
                return new $root.saass.GetDownloadUrls.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof saass.GetDownloadUrls.Response
             * @static
             * @param {saass.GetDownloadUrls.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof saass.GetDownloadUrls.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetDownloadUrls;
    })();

    saass.GetAppToken = (function() {

        /**
         * Properties of a GetAppToken.
         * @memberof saass
         * @interface IGetAppToken
         */

        /**
         * Constructs a new GetAppToken.
         * @memberof saass
         * @classdesc Represents a GetAppToken.
         * @implements IGetAppToken
         * @constructor
         * @param {saass.IGetAppToken=} [properties] Properties to set
         */
        function GetAppToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAppToken instance using the specified properties.
         * @function create
         * @memberof saass.GetAppToken
         * @static
         * @param {saass.IGetAppToken=} [properties] Properties to set
         * @returns {saass.GetAppToken} GetAppToken instance
         */
        GetAppToken.create = function create(properties) {
            return new GetAppToken(properties);
        };

        /**
         * Encodes the specified GetAppToken message. Does not implicitly {@link saass.GetAppToken.verify|verify} messages.
         * @function encode
         * @memberof saass.GetAppToken
         * @static
         * @param {saass.IGetAppToken} message GetAppToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAppToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAppToken message, length delimited. Does not implicitly {@link saass.GetAppToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof saass.GetAppToken
         * @static
         * @param {saass.IGetAppToken} message GetAppToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAppToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAppToken message from the specified reader or buffer.
         * @function decode
         * @memberof saass.GetAppToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {saass.GetAppToken} GetAppToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAppToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetAppToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAppToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof saass.GetAppToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {saass.GetAppToken} GetAppToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAppToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAppToken message.
         * @function verify
         * @memberof saass.GetAppToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAppToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAppToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof saass.GetAppToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {saass.GetAppToken} GetAppToken
         */
        GetAppToken.fromObject = function fromObject(object) {
            if (object instanceof $root.saass.GetAppToken)
                return object;
            return new $root.saass.GetAppToken();
        };

        /**
         * Creates a plain object from a GetAppToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof saass.GetAppToken
         * @static
         * @param {saass.GetAppToken} message GetAppToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAppToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAppToken to JSON.
         * @function toJSON
         * @memberof saass.GetAppToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAppToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAppToken.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof saass.GetAppToken
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof saass.GetAppToken
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {saass.GetAppToken.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {saass.GetAppToken.IRequest=} [properties] Properties to set
             * @returns {saass.GetAppToken.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link saass.GetAppToken.Request.verify|verify} messages.
             * @function encode
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {saass.GetAppToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link saass.GetAppToken.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {saass.GetAppToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {saass.GetAppToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetAppToken.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {saass.GetAppToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {saass.GetAppToken.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.saass.GetAppToken.Request)
                    return object;
                return new $root.saass.GetAppToken.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof saass.GetAppToken.Request
             * @static
             * @param {saass.GetAppToken.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof saass.GetAppToken.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetAppToken.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof saass.GetAppToken
             * @interface IResponse
             * @property {string|null} [baseUrl] Response baseUrl
             * @property {string|null} [appToken] Response appToken
             * @property {number|Long|null} [deadline] Response deadline
             */

            /**
             * Constructs a new Response.
             * @memberof saass.GetAppToken
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {saass.GetAppToken.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response baseUrl.
             * @member {string} baseUrl
             * @memberof saass.GetAppToken.Response
             * @instance
             */
            Response.prototype.baseUrl = "";

            /**
             * Response appToken.
             * @member {string} appToken
             * @memberof saass.GetAppToken.Response
             * @instance
             */
            Response.prototype.appToken = "";

            /**
             * Response deadline.
             * @member {number|Long} deadline
             * @memberof saass.GetAppToken.Response
             * @instance
             */
            Response.prototype.deadline = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {saass.GetAppToken.IResponse=} [properties] Properties to set
             * @returns {saass.GetAppToken.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link saass.GetAppToken.Response.verify|verify} messages.
             * @function encode
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {saass.GetAppToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.baseUrl != null && Object.hasOwnProperty.call(message, "baseUrl"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.baseUrl);
                if (message.appToken != null && Object.hasOwnProperty.call(message, "appToken"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.appToken);
                if (message.deadline != null && Object.hasOwnProperty.call(message, "deadline"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.deadline);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link saass.GetAppToken.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {saass.GetAppToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {saass.GetAppToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.saass.GetAppToken.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.baseUrl = reader.string();
                        break;
                    case 2:
                        message.appToken = reader.string();
                        break;
                    case 3:
                        message.deadline = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {saass.GetAppToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                    if (!$util.isString(message.baseUrl))
                        return "baseUrl: string expected";
                if (message.appToken != null && message.hasOwnProperty("appToken"))
                    if (!$util.isString(message.appToken))
                        return "appToken: string expected";
                if (message.deadline != null && message.hasOwnProperty("deadline"))
                    if (!$util.isInteger(message.deadline) && !(message.deadline && $util.isInteger(message.deadline.low) && $util.isInteger(message.deadline.high)))
                        return "deadline: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {saass.GetAppToken.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.saass.GetAppToken.Response)
                    return object;
                var message = new $root.saass.GetAppToken.Response();
                if (object.baseUrl != null)
                    message.baseUrl = String(object.baseUrl);
                if (object.appToken != null)
                    message.appToken = String(object.appToken);
                if (object.deadline != null)
                    if ($util.Long)
                        (message.deadline = $util.Long.fromValue(object.deadline)).unsigned = false;
                    else if (typeof object.deadline === "string")
                        message.deadline = parseInt(object.deadline, 10);
                    else if (typeof object.deadline === "number")
                        message.deadline = object.deadline;
                    else if (typeof object.deadline === "object")
                        message.deadline = new $util.LongBits(object.deadline.low >>> 0, object.deadline.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof saass.GetAppToken.Response
             * @static
             * @param {saass.GetAppToken.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.baseUrl = "";
                    object.appToken = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deadline = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deadline = options.longs === String ? "0" : 0;
                }
                if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                    object.baseUrl = message.baseUrl;
                if (message.appToken != null && message.hasOwnProperty("appToken"))
                    object.appToken = message.appToken;
                if (message.deadline != null && message.hasOwnProperty("deadline"))
                    if (typeof message.deadline === "number")
                        object.deadline = options.longs === String ? String(message.deadline) : message.deadline;
                    else
                        object.deadline = options.longs === String ? $util.Long.prototype.toString.call(message.deadline) : options.longs === Number ? new $util.LongBits(message.deadline.low >>> 0, message.deadline.high >>> 0).toNumber() : message.deadline;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof saass.GetAppToken.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetAppToken;
    })();

    return saass;
})();

module.exports = $root;
